import React, { Component } from "react";
import DefaultFieldsFilter from "./DefaultFieldsFilter";
import CustomFieldsFilter from "../DisplayData/CustomFieldsFilter";
import QueryGroups from "../DisplayData/QueryGroups";
import { Tabs } from "@adrianoferreira/wp-react-admin";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import Output from "./Output";
import Ordering from "../DisplayData/Ordering";
import OffsetLimit from "../DisplayData/OffsetLimit";

export const DisplayUsers = (props) => {

	return(
		<div id="poststuff" className="display-data-box">
			<div id="slugdiv" className="postbox">
				<h2 className="hndle ui-sortable-handle"><span>Display Users</span></h2>
				<div className="inside" style={{display: 'block'}}>

					<p>This action should be used whenever you want to output users as well as user meta fields.</p>

						{props.endpoint.displayUsers && props.endpoint.displayUsers.map(
							(el, index) =>

									<FieldGroupContext.Provider key={index} value={{
										action: 'displayUsers',
										currentItem: index,
										endpointId: props.id,
										endpoint: props.endpoint
									}}>

									<Tabs tabs={[
										{
											name:    'defaultFields',
											title:   'Default Fields Filter',
											content: <DefaultFieldsFilter group={'defaultFields'} key={index + '-defaultFields'}/>
										},
										{
											name: 'queryGroups',
											title: 'Query Groups',
											content: <QueryGroups key={index + '-queryGroups'} group={'queryGroups'}/>
										},
										{
											name: 'customFields',
											title: 'Custom Fields Filter',
											content: <CustomFieldsFilter key={index + '-customFields'} group={'customFields'}/>
										},
										{
											name: 'orderby',
											title: 'Ordering',
											content: <Ordering key={index + '-ordering'} action='displayTaxonomies'/>
										},
										{
											name: 'limit-offset',
											title: 'Limit and Offset (Pagination)',
											content: <OffsetLimit key={index + '-limit-offset'}/>
										},
										{
											name: 'output',
											title: 'Endpoint Output',
											content: <Output key={index + '-output'} group={'output'}/>
										},
									]} />

								</FieldGroupContext.Provider>
						)}

				</div>
			</div>
		</div>
	)
};
